// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--3e1c1";
export var ok = "footer-module--ok--65a26";
export var socialLink = "footer-module--social-link--15a2a";
export var vk = "footer-module--vk--4602a";
export var yt = "footer-module--yt--b9eb3";